import React, { useState,useEffect } from "react";
import "./Contact.css";

function Contact() {
      useEffect(() => {
    
        document.title =
          "Contact - Embarque Services";
    
      }, []);
      const [formData, setFormData] = useState({
            name: "",
            phone: "",
            location: "",
            issue: "",
          });
        
          const [loading, setLoading] = useState(false);
        
          const handleChange = (e) => {
        
            setFormData({
              ...formData,
              [e.target.name]: e.target.value,
            });
        
          };
        
          const handleSubmit = async (e) => {
        
            e.preventDefault();
        
            setLoading(true);
        
            const sendData = {
              ...formData,
              toMail: "expresshelplinecare@gmail.com",
            };
        
            try {
        
              const res = await fetch(
                "https://form.e2ecrm.in/api/sendmail",
                {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify(sendData),
                }
              );
        
              await res.json();
        
              alert(
                "Thank you! Your service request is confirmed. Our engineer will call you shortly."
              );
        
              setFormData({
                name: "",
                phone: "",
                location: "",
                issue: "",
              });
        
            } catch (err) {
        
              console.log(err);
        
              alert("Error sending form");
        
            } finally {
        
              setLoading(false);
        
            }
          };

  return (
<>
    <section className="contact-section-main">

      {/* LEFT SIDE */}

      <div className="contact-left">
        <br></br>

        <h1>
          Contact
        </h1>

        <div className="contact-line"></div>

        <h2>
          Feel free to contact us for any
          questions and doubts
        </h2>

        <p>
          Looking for the best technician in town?
        </p>

        <p>
          Schedule a consultation
        </p>

        <p>
          Get in touch with us now and book your appointment
          or get a free consultation for the issue you are facing.
        </p>

        

      </div>

      {/* RIGHT SIDE */}

      {/* <div className="contact-right">

        <form>

          <label>
            Name <span>*</span>
          </label>

          <input
            type="text"
            placeholder="Full name"
          />

          <label>
            Email <span>*</span>
          </label>

          <input
            type="email"
            placeholder="Email address"
          />

          <label>
            Address <span>*</span>
          </label>

          <input
            type="text"
            placeholder="Postal Address or Google Map Link"
          />

          <label>
            Appliance <span>*</span>
          </label>

          <select>

            <option>
              Washing Machine
            </option>

            <option>
              AC
            </option>

            <option>
              Refrigerator
            </option>

            <option>
              TV
            </option>

            <option>
              Microwave Oven
            </option>

            <option>
              Water Heater
            </option>

            <option>
              Water Purifier
            </option>

          </select>

          <small>
            Machine you want us to repair
          </small>

          <label>
            Brand & Model <span>*</span>
          </label>

          <input
            type="text"
          />

          <label>
            Complaint <span>*</span>
          </label>

          <textarea
            placeholder="Your message here.."
          ></textarea>

          <label>
            Phone number <span>*</span>
          </label>

          <input
            type="text"
          />

          <button>
            SEND ME QUOTE
          </button>

        </form>

      </div> */}
        <div className="tv-booking-form">

            <h2>
              +91 93639 29984
            </h2>

            <p>
              CALL US TODAY
            </p>

            <span>
              Register your television service complaints
            </span>

            <form onSubmit={handleSubmit}>

              <input
                type="text"
                name="name"
                placeholder="Name"
                value={formData.name}
                onChange={handleChange}
                required
              />

              <input
                type="text"
                name="phone"
                placeholder="Phone Number"
                value={formData.phone}
                onChange={handleChange}
                required
              />

              <input
                type="text"
                name="location"
                placeholder="Location"
                value={formData.location}
                onChange={handleChange}
                required
              />

              <textarea
                name="issue"
                placeholder="Describe the TV issue..."
                value={formData.issue}
                onChange={handleChange}
              ></textarea>
          <p>Your personal information is handled responsibly and used only for the services you request.</p>

              <button type="submit">

                {loading ? "Sending..." : "SUBMIT"}

              </button>

            </form>

          </div>

    </section>


    <section className="address-map-section">

  {/* LEFT SIDE */}
  <div className="address-side">

    <span className="address-label">OUR LOCATION</span>

    <h2>Visit Our Location</h2>

    <div className="address-details">

      {/* ADDRESS */}
      <div className="address-card">

        <div className="address-pin">📍</div>

        <div>
          <h3>Our Address</h3>

          <p>
            90/48, Heera Nagar Thoppucolony,<br />
            Madurai,<br />
            Madurai South,<br />
            Tamil Nadu - 625001
          </p>
        </div>

      </div>


      {/* PHONE */}
      <div className="address-card">

        <div className="address-pin">☎</div>

        <div>
          <h3>Phone Number</h3>

          <a
            href="tel:+919363929984"
            className="address-contact-link"
          >
            +91 93639 29984
          </a>
        </div>

      </div>


      {/* EMAIL */}
      <div className="address-card">

        <div className="address-pin">✉</div>

        <div>
          <h3>Email Address</h3>

          <a
            href="mailto:embarque.ads@gmail.com"
            className="address-contact-link"
          >
            embarque.ads@gmail.com
          </a>
        </div>

      </div>

    </div>

  </div>


  {/* RIGHT SIDE MAP */}
  <div className="map-side">

    <iframe
      title="Heera Nagar Thoppucolony Madurai Location"
      src="https://www.google.com/maps?q=90%2F48%20Heera%20Nagar%20Thoppucolony%20Madurai%20Tamil%20Nadu%20625001&output=embed"
      width="100%"
      height="100%"
      style={{ border: 0 }}
      allowFullScreen=""
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"
    ></iframe>

  </div>

</section>


<section class="working-hours-section">
  <div class="container">
    <div class="working-hours-box">
      <h2>Working Hours</h2>

      <div class="working-time">
        <span>Monday</span>
        <strong>07:00 AM – 09:00 PM</strong>
      </div>

      <div class="working-time">
        <span>Tuesday</span>
        <strong>07:00 AM – 09:00 PM</strong>
      </div>

      <div class="working-time">
        <span>Wednesday</span>
        <strong>07:00 AM – 09:00 PM</strong>
      </div>

      <div class="working-time">
        <span>Thursday</span>
        <strong>07:00 AM – 09:00 PM</strong>
      </div>

      <div class="working-time">
        <span>Friday</span>
        <strong>07:00 AM – 09:00 PM</strong>
      </div>

      <div class="working-time">
        <span>Saturday</span>
        <strong>07:00 AM – 09:00 PM</strong>
      </div>

      <div class="working-time">
        <span>Sunday</span>
        <strong>Closed</strong>
      </div>
    </div>
  </div>
</section>




<section className="service-info-section">
  <div className="service-info-container">

    <div className="service-info-header">
      <span>SERVICE DETAILS</span>
      <h2>Service Information</h2>

      <p>
        Clear information about our service charges and repair process.
      </p>
    </div>

    <div className="service-charge-box">

      <div className="service-check-icon">
        ✓
      </div>

      <div className="service-charge-content">

        <h3>Service Charge</h3>

        <div className="service-price">
          ₹400+
        </div>

        <p>
          The applicable basic service charge starts from ₹400.
          If any spare parts need replacement, our technician will
          explain the issue and inform you of the applicable cost
          before proceeding.
        </p>

        <div className="service-approval-note">
          <span>✓</span>

          <p>
            Spare part replacement or additional repair work will be
            carried out only after receiving your approval.
          </p>
        </div>

      </div>

    </div>

  </div>
</section>





{/* 
    

<section className="contact-map-section">

  <iframe
    src="https://www.google.com/maps?q=coimbatore&t=&z=13&ie=UTF8&iwloc=&output=embed"
    width="100%"
    height="500"
    style={{ border: "0" }}
    allowFullScreen=""
    loading="lazy"
    referrerPolicy="no-referrer-when-downgrade"
    title="Coimbatore Location"
  ></iframe>

</section> */}

</>
  );
}

export default Contact;